module.exports = __webpack_public_path__ + "img/syukyaku-top-ira007.5ce5c7cc.png";